export default "__VITE_ASSET__8ea78f62__"